import { useEffect, useState } from 'react';

/**
 * Simple hook to detect if virtual keyboard is likely visible.
 * Uses visualViewport API to detect viewport shrinkage.
 */
export function useKeyboardVisible() {
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);

  useEffect(() => {
    // Only run on mobile
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (!isMobile) return;

    const viewport = window.visualViewport;
    if (!viewport) return;

    // Store initial height
    const initialHeight = window.innerHeight;

    const handleResize = () => {
      // If viewport is significantly smaller than initial, keyboard is likely open
      const heightDiff = initialHeight - viewport.height;
      setIsKeyboardVisible(heightDiff > 150);
    };

    viewport.addEventListener('resize', handleResize);
    handleResize();

    return () => viewport.removeEventListener('resize', handleResize);
  }, []);

  return isKeyboardVisible;
}
